import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useUserStore } from '@/store/user';

export default /*@__PURE__*/_defineComponent({
  __name: 'Container',
  setup(__props) {

const userStore = useUserStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w1440", {isFull: _unref(userStore).isOpenScreenFull}]),
    style: {"margin":"0 auto","min-width":"1007px"}
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})